"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.patientProgramStatus = exports.notificationUpdateAction = exports.notificationStatus = exports.userDataProperties = exports.programAccessStatus = exports.engineTaskTypes = exports.taskSettingKeys = exports.systemProgramProfiles = exports.orgLicence = exports.contentElemenIdPrefix = exports.workflowStatuses = exports.thresholdTypes = exports.customContentElementTypes = exports.specialContentElementTypes = exports.questionContentElementTypes = exports.defaultContentElementTypes = exports.contentPatchOperations = exports.patientPatchOperations = exports.patientDialogChannels = exports.freetextInputTypes = exports.loginTypes = exports.IdProviders = exports.sensorTypes = exports.patientFlagTypes = exports.sortDataType = exports.sortDirection = exports.elementConditionStates = exports.fileTypes = exports.logoutReasons = exports.accessRoles = exports.scheduleRepeatPeriod = exports.systemElementGroups = exports.patientUserLevels = exports.loginLevels = exports.appRoleLevels = exports.appRoles = exports.formAnswerTypes = exports.linkTypes = exports.elementTypes = void 0;
exports.elementTypes = {
    html: 'Html',
    text: 'Text',
    audio: 'Audio',
    video: 'Video',
    image: 'Image',
    file: 'File',
    link: 'Link',
    form: 'Form',
    script: 'Script',
    reference: 'Reference',
};
exports.linkTypes = {
    internal: 'Internal',
    task: 'Task',
    module: 'Module',
    program: 'Program',
    file: 'File',
    url: 'ExternalPage',
    youtube: 'Youtube',
    vimeo: 'Vimeo',
    audio: 'Audio',
    video: 'Video',
    image: 'Image',
};
exports.formAnswerTypes = {
    freetext: 'Freetext',
    singleChoice: 'SingleChoice',
    multipleChoice: 'MultipleChoice',
    scale: 'Scale',
    table: 'Table',
    switch: 'Switch',
    action: 'Action',
};
exports.appRoles = {
    portalAdmin: 'PortalAdmin',
    customerAdmin: 'CustomerAdmin',
    organizationAdmin: 'OrganizationAdmin',
    userAdmin: 'UserAdmin',
    systemsResponsible: 'SystemsResponsible',
    patientAdmin: 'PatientAdmin',
    manager: 'Manager',
    programAdmin: 'ProgramAdmin',
    therapist: 'Therapist',
    externalTherapist: 'ExternalTherapist',
    researcher: 'Researcher',
    user: 'User',
    contactPerson: 'ContactPerson',
    none: 'None',
    isTherapist: function (roles) { return roles === null || roles === void 0 ? void 0 : roles.reduce(function (prev, r) { return prev
        || r === 'Therapist' || r === 'PatientAdmin' || r === 'OrganizationAdmin' || r === 'PortalAdmin'; }, false); },
    isEditor: function (roles) { return roles === null || roles === void 0 ? void 0 : roles.reduce(function (prev, r) { return prev
        || r === 'ProgramAdmin' || r === 'OrganizationAdmin' || r === 'PortalAdmin'; }, false); },
    canReadOrgReports: function (roles) { return roles === null || roles === void 0 ? void 0 : roles.reduce(function (prev, r) { return prev
        || r === 'PortalAdmin' || r === 'OrganizationAdmin' || r === 'SystemsResponsible' || r === 'Manager'; }, false); },
    // eslint-disable-next-line no-use-before-define, @typescript-eslint/no-use-before-define
    isLimitedPatientAccess: function (role) { return !(exports.appRoleLevels[role] >= exports.appRoleLevels[exports.appRoles.therapist]); },
    // eslint-disable-next-line no-use-before-define, @typescript-eslint/no-use-before-define
    isAdminPatientAccess: function (role) { return role === 'PortalAdmin' || role === 'OrganizationAdmin' || role === 'SystemsResponsible' || role === 'PatientAdmin'; },
};
exports.appRoleLevels = (_a = {},
    _a[exports.appRoles.portalAdmin] = 100,
    _a[exports.appRoles.customerAdmin] = 95,
    _a[exports.appRoles.organizationAdmin] = 90,
    _a[exports.appRoles.userAdmin] = 85,
    _a[exports.appRoles.systemsResponsible] = 80,
    _a[exports.appRoles.patientAdmin] = 60,
    _a[exports.appRoles.manager] = 38,
    _a[exports.appRoles.programAdmin] = 35,
    _a[exports.appRoles.therapist] = 30,
    _a[exports.appRoles.externalTherapist] = 28,
    _a[exports.appRoles.researcher] = 22,
    _a[exports.appRoles.user] = 20,
    _a[exports.appRoles.contactPerson] = 10,
    _a);
exports.loginLevels = {
    none: 0,
    key: 1,
    password: 2,
    twoFactor: 3,
    level4: 4,
};
exports.patientUserLevels = {
    none: 'None',
    anonymous: 'Anonymous',
    person: 'Person',
    patient: 'Patient',
};
exports.systemElementGroups = {
    main: 'Main',
    consent: 'Consent',
    scheduled: 'Scheduled',
    app: 'App',
    therapist: 'Therapist',
};
exports.scheduleRepeatPeriod = {
    day: 'Day',
    week: 'Week',
    month: 'Month',
};
exports.accessRoles = {
    none: 'None',
    limited: 'Limited',
    read: 'Read',
    write: 'Write',
    owner: 'Owner',
    admin: 'Admin',
    hasWriteAccess: function (role) { return role === 'Write' || role === 'Owner' || role === 'Admin'; },
    isLimitedAccess: function (role) { return !role || role === 'Limited'; },
};
exports.logoutReasons = {
    tokenExpired: '910',
    idleTimeout: '911',
    changeOrg: '1011',
    invalidState: '912',
};
exports.fileTypes = {
    file: 'File',
    image: 'Image',
    audio: 'Audio',
    video: 'Video',
    document: 'Document',
};
exports.elementConditionStates = {
    none: 'None',
    visible: 'Visible',
    hidden: 'Hidden',
    accepted: 'Accepted',
    rejected: 'Rejected',
};
exports.sortDirection = {
    asc: 'asc',
    desc: 'desc',
};
exports.sortDataType = {
    default: 'default',
    number: 'number',
    date: 'date',
};
exports.patientFlagTypes = {
    criticalScore: 'CriticalScore',
    inactivePatient: 'InactivePatient',
    messageFollowup: 'MessageFollowup',
    responseFollowup: 'ResponseFollowup',
    checkForSurplusInformation: 'CheckForSurplusInformation',
};
exports.sensorTypes = {
    unknown: 'Unknown',
    fitbit: 'Fitbit',
    garmin: 'Garmin',
};
exports.IdProviders = {
    youwell: 'Youwell',
    idPorten: 'IdPorten',
};
exports.loginTypes = {
    password: 'Password',
    idPorten: 'IdPorten',
    twoFactor: 'TwoFactor',
    selfStart: 'SelfStart',
};
exports.freetextInputTypes = {
    default: 'Default',
    singleLineText: 'SingleLineText',
    email: 'Email',
    phone: 'Phone',
    number: 'Number',
    date: 'Date',
    dateAndTime: 'DateAndTime',
    time: 'Time',
    richText: 'RichText',
};
exports.patientDialogChannels = {
    chat: 'YouwellChat',
    sms: 'Sms',
};
exports.patientPatchOperations = {
    addGroupMembership: 'AddGroupMembership',
    removeGroupMembership: 'RemoveGroupMembership',
};
exports.contentPatchOperations = {
    changeOwner: 'ChangeOwner',
};
exports.defaultContentElementTypes = {
    default: 'Default',
    box: 'Box',
    card: 'Card',
    readMore: 'ReadMore',
    linkedResponse: 'LinkedResponse',
};
exports.questionContentElementTypes = {
    questionnaire: 'Questionnaire',
    quiz: 'Quiz',
    bubbleChoice: 'BubbleChoice',
    bullseye: 'BullsEye',
    collapsedTable: 'CollapsedTable',
};
exports.specialContentElementTypes = {
    hidden: 'Hidden',
    connectedBoxes: 'ConnectedBoxes',
};
exports.customContentElementTypes = {
    quizResponse: 'QuizResponse',
    routeSelection: 'RouteSelection', // Used by eMeistring Depresjon
};
exports.thresholdTypes = {
    lessThan: 'LessThan',
    moreThan: 'MoreThan',
    equals: 'Equals',
    none: 'None',
};
exports.workflowStatuses = {
    progress: 100,
    review: 300,
    ready: 500,
    parse: function (config) { return (config === null || config === void 0 ? void 0 : config.map(function (item) {
        var kv = item.split(':');
        return {
            id: Number(kv[0]),
            name: kv[1],
        };
    })) || []; },
};
exports.contentElemenIdPrefix = 'ywE';
exports.orgLicence = {
    None: 0,
    Trial: 5,
    Limited: 10,
    Unlimited: 100,
};
exports.systemProgramProfiles = {
    Default: 'Default',
    Empty: 'Empty',
    All: 'All',
};
exports.taskSettingKeys = {
    exportLabel: 'export-label',
};
exports.engineTaskTypes = {
    checkForNewFeedback: 'CheckForNewFeedback',
    setRandomizedReminders: 'SetRandomizedReminders',
};
exports.programAccessStatus = {
    default: 'Default',
    private: 'Private',
    clientLibrary: 'ClientLibrary',
    publicLibrary: 'PublicLibrary',
    public: 'Public',
};
exports.userDataProperties = {
    bedtimePlan: {
        bedTime: 'sleepPlan.bedTime',
        wakeTime: 'sleepPlan.wakeTime',
    },
};
exports.notificationStatus = {
    created: 'Created',
    sent: 'Sent',
    notSent: 'NotSent',
    Invalid: 'Invalid',
    canceled: 'Canceled',
};
exports.notificationUpdateAction = {
    resend: 'Resend',
    cancel: 'Cancel',
    sendNow: 'SendNow',
};
exports.patientProgramStatus = {
    notStarted: 'NotStarted',
    active: 'Active',
    inactive: 'Inactive',
    ended: 'Ended',
    deleted: 'Deleted',
    programDeleted: 'ProgramDeleted',
};
